"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _simpleDataReducer = require("../../../common/utils/simpleDataReducer");
var actions = _interopRequireWildcard(require("./actions"));
var _const = require("./const");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const getMyOrderListReducer = (0, _simpleDataReducer.createReducer)(actions.GET_MY_ORDER_JSON_API);
const getOrderDetailsReducer = (0, _simpleDataReducer.createReducer)(actions.GET_ORDER_DETAILS_API);
const trackProductReducer = (0, _simpleDataReducer.createReducer)(actions.TRACK_NOW_API);
const cancelOrderReducer = (0, _simpleDataReducer.createReducer)(actions.CANCEL_ORDER_API);
const returnOrderReducer = (0, _simpleDataReducer.createReducer)(actions.RETURN_ITEM_API);
const mergeCartReducer = (0, _simpleDataReducer.createReducer)(actions.MERGE_CART_API);
const newMergeCartReducer = (0, _simpleDataReducer.createReducer)(actions.NEW_MERGE_CART_API);
const cancelMergeCartReducer = (0, _simpleDataReducer.createReducer)(actions.CANCEL_MERGE_CART_API);
const reorderReducer = (0, _simpleDataReducer.createReducer)(actions.REORDER_API);
const getMyInStoreOrderListReducer = (0, _simpleDataReducer.createReducer)(actions.GET_MY_INSTORE_ORDER_API);
const getInStoreOrderDetailsReducer = (0, _simpleDataReducer.createReducer)(actions.GET_INSTORE_ORDER_DETAILS_API);
const downloadInvoiceReducer = (0, _simpleDataReducer.createReducer)(actions.DOWNLOAD_INVOICE_API);
const getPrescriptionOrderDetailsReducer = (0, _simpleDataReducer.createReducer)(actions.GET_PRESCRIPTION_ORDER_DETAILS_API);
const createReturnItemReducer = (0, _simpleDataReducer.createReducer)(actions.CREATE_RETURN_ITEM_API);
const getReturnStatusReducer = (0, _simpleDataReducer.createReducer)(actions.GET_RETURN_STATUS_API);
const getReturnDetailsReducer = (0, _simpleDataReducer.createReducer)(actions.GET_RETURN_DETAILS_API);
var _default = exports.default = {
  [_const.GET_MY_ORDER_JSON]: getMyOrderListReducer,
  [_const.ORDER_DETAILS_REDUCER]: getOrderDetailsReducer,
  [_const.CANCEL_ORDER_REDUCER]: cancelOrderReducer,
  [_const.TRACK_PACKAGE_REDUCER]: trackProductReducer,
  [_const.RETURN_ORDER_REDUCER]: returnOrderReducer,
  [_const.MERGE_CART]: mergeCartReducer,
  [_const.NEW_MERGE_CART]: newMergeCartReducer,
  [_const.CANCEL_MERGE_CART]: cancelMergeCartReducer,
  [_const.REORDER]: reorderReducer,
  [_const.DOWNLOAD_INVOICE_REDUCER]: downloadInvoiceReducer,
  [_const.GET_MY_INSTORE_ORDER]: getMyInStoreOrderListReducer,
  [_const.INSTORE_ORDER_DETAILS]: getInStoreOrderDetailsReducer,
  [_const.GET_PRESCRIPTION_ORDER_DETAILS]: getPrescriptionOrderDetailsReducer,
  [_const.CREATE_RETURN_ITEM]: createReturnItemReducer,
  [_const.GET_RETURN_STATUS]: getReturnStatusReducer,
  [_const.GET_RETURN_DETAILS]: getReturnDetailsReducer
};